/*
import {
    API_HOST,
} from '../config'
*/

import history from '../history'

const UA = window.navigator.userAgent

/* detecting wechat */
function isWechat(): boolean {
    if (UA.includes('micromessenger')) {
        return true
    }
    return false
}

function cutString(s: string, n: number): string {
    if (s.length > n) {
        return s.substring(0, n) + '...'
    } else {
        return s
    }
}

function json2Form(json: object): string {
    if (!json) {
        return ''
    }

    let str = []
    for (let p in json) {
        if (json.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(json[p]))
        }
    }
    return str.join('&')
}

async function ajax(url: string, payload: object = {}, method: string) {
    if (!url) {
        return
    }

    let init = {}
    const auth = localStorage.getItem('token') ? ('JWT ' + localStorage.getItem('token')) : ''

    if (method === 'GET' || method === 'get') {
        url = url + json2Form(payload)

        init = {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Authorization': auth
            },
        }
    } else if (method === 'POST' || method === 'post') {
        init = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Authorization': auth
            },
            body: json2Form(payload)
        }
    } else {
        return
    }

    // url = API_HOST + url

    try {
        const response = await fetch(url, init)

        if (
            response.status === 500 ||
            response.status === 404
        ) {
            return Object.assign({}, {error: response.statusText}, {hasError: true})
        }

        const responseJson = await response.json()

        if (response.status.toString()[0] !== '2') {
            return {...responseJson, hasError: true}
        } else {
            return responseJson
        }
    } catch (error) {
        return error.statusText
    }
}

function toInt(num: string | number): number {
    if (typeof num === 'number') {
        num = num.toString()
    }

    if (num) {
        return parseInt(num, 10)
    }

    return 0
}

function getCookies() {
    let cookies = {
        token: ''
    }
    for (let cookie of document.cookie.split('; ')) {
        let [name, value] = cookie.split('=')
        cookies[name] = decodeURIComponent(value)
    }
    return cookies
}

function createCookie(name: string, value: string, days: number) {
    let expires
    if (days) {
        let date = new Date()
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
        expires = '; expires=' + date.toUTCString()
    } else {
        expires = ''
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/'
}

function clearCookieByName(name: string) {
    createCookie(name, '', -1)
}

function checkRegex(regex: any, s: string): boolean {
    const re = new RegExp(regex)
    return re.test(s)
}

function toLogin(backUrl: string) {
    if (!backUrl) {
        backUrl = window.location.href
    }

    localStorage.setItem('BackUrl', backUrl)

    history.push('/login')
}

function isEmpty(obj: object) {
    return Object.keys(obj).length === 0 && obj.constructor === Object
}

function dateFormat(date: any) {
    let temp = date.replace(/-/g, '/')
    return new Date(temp)
}

function compare(property: any) {
    let value1, value2
    return function (obj1: any, obj2: any) {
        if (property === 'created_at') {
            const temp = '_source'
            value1 = Date.parse(obj1[temp][property]);
            value2 = Date.parse(obj2[temp][property]);
        } else {
            value1 = obj1[property];
            value2 = obj2[property];
        }
        return value1 - value2;     // 升序 、2 - 1 降序
    }
}

function sortReports(index: any, data: any) {
    switch (index) {
        case '_score':
            return data.sort(compare('_score'));
        case 'created_at':
            return data.sort(compare('created_at'));
        default:
            break
    }
}
function  objToArray(obj: object) {
    let arr = []
    for (let i in obj) {
        if (i) {
            arr.push(obj[i])
        }
    }
    // console.log(arr)
    return arr
}

 function getLength(str: any) {
    ///<summary>获得字符串实际长度，中文2，英文1</summary>
    ///<param name="str">要获得长度的字符串</param>
    let realLength = 0, len = str.length, charCode = -1;
    for (let i = 0; i < len; i++) {
        charCode = str.charCodeAt(i);
        if (charCode >= 0 && charCode <= 128) realLength += 1;
        else realLength += 2;
    }
    return realLength;
}

function IndexString(str1: string, str2: string) {
    let s = str2.indexOf(str1);
    if (Number(s) >= 0) {
        return true
    } else {
        return false
    }
}

export {
    UA,
    isWechat,
    cutString,
    ajax,
    toInt,
    getCookies,
    createCookie,
    clearCookieByName,
    checkRegex,
    toLogin,
    isEmpty,
    dateFormat,
    sortReports,
    objToArray,
    getLength,
    IndexString,
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/util/index.tsx